import React from "react";
import { Link } from "gatsby";
import Layout from "../../components/Layout/Layout";
import SEO from "../../components/SEO/SEO";
import amcStyles from "./amc.module.css";
import { FaCoins } from "react-icons/fa";
import { getRoundedInrFormatWithSymbol, sendToUrl } from "../../utilities";

const AMC = ({ pageContext: { allAmcs, pageLink } }) => {
  return (
    <Layout href={pageLink}>
      <SEO link={pageLink} />
      <div className={amcStyles.amcWrapper}>
        <h1 className={amcStyles.heading}>Mutual Funds AMCs</h1>
        <div className={amcStyles.container}>
          {allAmcs &&
            allAmcs.map((amc, key) => <AmcCard amc={amc} key={key} />)}
        </div>
      </div>
    </Layout>
  );
};

export const AmcCard = ({ amc }) => {
  const amcLinkName = amc.display_name_id.split("_").join("-");
  let amcImage = amc.display_name_id == "reliance_mutual_fund" ?
    "nippon_india_mutual_fund" : amc.display_name_id

  return (
    <div className={amcStyles.amcCard}>
      <Link to={sendToUrl(`/mutual-funds/amc/${amcLinkName}/`)}>
        <div className="d-f">
          <img
            src={`https://assets.piggy.co.in/amc/icons/${amcImage}_piggy.svg`}
            className={amcStyles.logo}
            alt={amc.name + " Logo"}
          />
          <div className="d-f-c j-c-c">
            <div className={amcStyles.title}>{amc.name}</div>
            <div className="d-f a-i-c" style={{ marginTop: "8px" }}>
              <FaCoins
                style={{ color: "rgb(249, 195, 30)", marginRight: "8px" }}
              />
              <span className={amcStyles.aumText}>AUM</span>
              <span className={amcStyles.aumValue}>
                {getRoundedInrFormatWithSymbol(amc.aum)} Cr
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default AMC;
